<template>
    <div class="team-area pt-100 pb-75" >
        <div class="container">
            <div class="section-title" >
                <!-- <span class="sub-title text-uppercase  ">{{fieldname}}</span> -->
                <h2>Services We Are Offer</h2>
            </div>
              <div class="row justify-content-center">
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6" v-for="offers in data" :key="offers?.id">
                        <div class="single-team-box">
                            <div class="image">
                                <div
                                 ><img :src='`https://backend.meander.software/${offers?.image?.url}`' :alt="offers?.image?.alternativeText || offers?.name + ' - Service Image' || 'Service Image'"/></div>
                            </div>
                            <div class="content">
                                <h3>{{offers?.name}}</h3><span>{{offers?.role}}</span>
                            </div>
                        </div>
                    </div>
                  
            </div>

         
    </div>
</div></template>

<script>
export default {
    name: 'IndustriesService',
    props:{
     data:[],
    },
   
}
</script>